module.exports = __webpack_public_path__ + "img/productions_27.ef418cae.png";